import React from 'react';
import { fundCardPropTypes, fundCardDefaultPropTypes } from '../../common/prop-types';
import Type from '../../../shared/fund/type';
import WholesaleTag from '../../../shared/fund/wholesale-tag';
import {
  Primary,
  AssetClass,
  Container,
  Name,
  FlexRow,
} from './styles';
import Logo from './logo';
import Summary from './summary';
import Performance from './performance';
import Fees from './fees';

export default function Desktop(props) {
  const {
    name,
    fundType,
    fundAssetClass,
    inceptionDate,
    minimumInvestment,
    managementFee,
    performanceFee,
    isPerformanceFeeCharged,
    totalCostRatio,
    financialYearEndFeesDate,
    returnSinceInception,
    oneMonthReturnPercent,
    oneYearReturnPercent,
    threeYearReturnPercent,
    fiveYearReturnPercent,
    logoColor,
    logoPictureUrl,
    currentView,
    wholesale,
  } = props;

  return (
    <Container>
      <Logo color={logoColor} url={logoPictureUrl} />
      <Primary>
        <FlexRow>
          {!!fundType && <Type type={fundType} />}
          {wholesale && <WholesaleTag />}
        </FlexRow>
        <Name>{name}</Name>
        <AssetClass>{fundAssetClass}</AssetClass>
      </Primary>
      {currentView === 'summary' && (
        <Summary
          minimumInvestment={minimumInvestment}
          managementFee={managementFee}
          returnSinceInception={returnSinceInception}
          inceptionDate={inceptionDate}
        />
      )}
      {currentView === 'performance' && (
        <Performance
          inceptionDate={inceptionDate}
          oneMonthReturnPercent={oneMonthReturnPercent}
          oneYearReturnPercent={oneYearReturnPercent}
          threeYearReturnPercent={threeYearReturnPercent}
          fiveYearReturnPercent={fiveYearReturnPercent}
          returnSinceInception={returnSinceInception}
        />
      )}
      {currentView === 'fees' && (
        <Fees
          managementFee={managementFee}
          performanceFee={performanceFee}
          isPerformanceFeeCharged={isPerformanceFeeCharged}
          totalCostRatio={totalCostRatio}
          financialYearEndFeesDate={financialYearEndFeesDate}
        />
      )}
    </Container>
  );
}

Desktop.propTypes = fundCardPropTypes;
Desktop.defaultProps = fundCardDefaultPropTypes;
